/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
  <div class="membership-container">

    <div v-if="esInstalador" class="active-wrapper">

      <div class="section-header-row">
        <h2 class="section-subtitle">Tu Suscripción</h2>
      </div>

      <div class="dashboard-card active-state">
        <div class="dashboard-body-triad">

          <div class="column-info">
            <h3 class="column-label">Detalles de la cuenta</h3>

            <div class="status-inline-wrapper">
              <span :class="['status-badge', membresia.activa ? 'active' : 'inactive']">
                <span class="pulse-dot"></span> 
                {{ membresia.activa ? 'Activa' : 'Inactiva' }}
              </span>
            </div>

            <div class="data-group">
              <label>Plan Asignado</label>
              <p class="data-value highlight-text">{{ membresia.plan }}</p>
            </div>

            <div class="data-group">
              <label>Vigencia hasta</label>
              <p class="data-value">{{ membresia.vencimiento }}</p>
            </div>

            <div class="data-group" v-if="membresia.activa">
               <label>Beneficio Principal</label>
               <p class="data-value" style="font-size: 0.9rem; color: #64748b;">
                 Acceso total al panel de instalaciones
               </p>
            </div>
          </div>

          <div class="vertical-divider desktop-only"></div>

          <div class="column-action-card">
            <span class="billing-label">Renovación Mensual</span>
            <div class="billing-card-clean">

              <div class="billing-price-row">
                <span class="currency">$</span>
                <span class="amount">999</span>
                <span class="mxn">MXN /mes</span>
              </div>
            </div>

            <div class="membership-container">
              <button v-if="membresia.activa" class="btn-cancel-subtle" @click="abrirConfirmacion">
                Cancelar renovación automática
              </button>

              <ModalConfirmacionEliminar
                v-if="showConfirmarCancelacion"
                :mensajeExito="'¿Estás seguro de que deseas cancelar la renovación automática?'"
                :nombreUsuario="''" 
                @cancelar="showConfirmarCancelacion = false"
                @confirmar="ejecutarCancelacion"
                @cerrarModal="showConfirmarCancelacion = false"
              />

              <ModalExito
                :mostrarExito="showModalExito"
                :mensajeExito="mensajeBackend"
                @cancelar="finalizarProceso"
              />
              <ModalError
                v-if="showModalError"
                :mostrarExito="showModalError"
                :mensajeExito="mensajeBackend"
                @click="cerrarError"
              />

              <LoadScreen v-if="cargando" />
            </div>
          </div>

          <div class="vertical-divider desktop-only"></div>

          <div class="column-benefits">
            <h3 class="column-label">Incluido en tu plan</h3>
            <ul class="clean-benefits-list">
              <li v-for="(benefit, index) in beneficiosUnicos" :key="index">
                <i class="fa-solid fa-check icon-check-primary"></i>
                <span>{{ benefit }}</span>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <div v-else class="generic-info-wrapper">
      <div class="info-card">
        <div class="info-icon">
             <i class="fa-regular fa-user"></i>
        </div>
        <h3>Información de Perfil</h3>
        <p>
          Hola <strong>{{ usuario.nombre }}</strong>, tu rol actual es <span class="rol-tag">{{ usuario.rol }}</span>.
        </p>
        <p class="sub-text">
          La gestión de membresías y pagos está habilitada únicamente para cuentas de tipo <b>Instalador</b>.
        </p>
      </div>
    </div>

  </div>
</template>

<script>
import pagosService from '@/services/pagosService';
import ModalConfirmacionEliminar from "@/components/Modales/ModalConfirmacion.vue";
import ModalExito from "@/components/Modales/ModalExito.vue";
import ModalError from "@/components/Modales/ModalError.vue";
import LoadScreen from "@/components/Forms/LoadScreen.vue";

export default {
  components: { 
    ModalConfirmacionEliminar, 
    ModalExito,
    ModalError,
    LoadScreen },
  props: ['membresia', 'usuario'],
  data() {
    return {
      cargando: false,
      showConfirmarCancelacion: false,
      showModalExito: false,
      showModalError: false,
      mensajeBackend: '',
      errorMsg: '',
      beneficiosUnicos: [
        'Acceso ilimitado a herramientas',
        'Soporte técnico prioritario',
        'Exportación de reportes',
        'Sin publicidad',
        'Nuevas funcionalidades beta'
      ]
    };
  },
  computed: {
    esInstalador() {
      return this.usuario?.rol === 'Instalador';
    }
  },
  methods: {
    abrirConfirmacion() {
      this.showConfirmarCancelacion = true;
    },
    async procesarPago() {
      this.cargando = true;
      this.errorMsg = '';
      
      try {
        const response = await pagosService.crearSesionDePago();
        
        if (response.data.url) {
            window.location.href = response.data.url; 
        } else {
            this.errorMsg = "No se recibió el enlace de pago.";
        }
        
      } catch (error) {
        console.error("Error iniciando pago:", error);
        this.errorMsg = "Error al conectar con el servidor de pagos.";
        this.cargando = false;
      }
    },
    async ejecutarCancelacion() {
      this.cargando = true;
      this.showConfirmarCancelacion = false;
      
      try {
        const response = await pagosService.cancelarSuscripcion();
        
        if(response.data){
          this.mensajeBackend = "Cancelación realizada. Tu suscripción seguirá activa y se restringirá el acceso una vez finalizado tu periodo actual.";
          this.showModalExito = true;
        }        
      } catch (error) {
        console.error("Error al cancelar:", error);
        this.mensajeBackend = "No se pudo procesar la cancelacion. Inteta mas tarde";
        this.showModalError = true;
        setTimeout(() => {
          this.cerrarError();
        }, 2500);
      } finally {
        this.cargando = false;
      }
    },
    finalizarProceso() {
      this.showModalExito = false;
      this.$emit('gestionar-membresia', 'cancelado_exito');
    },
    cerrarError() {
      this.showModalError = false;
      this.mensajeBackend = '';
    },
  }
};
</script>

<style scoped>
.membership-container {
  --mc-primary: #4652e8;
  --mc-primary-dark: #3740b0;
  --mc-success: #10b981;
  --mc-text-main: #1e293b;
  --mc-text-muted: #64748b;
  --mc-border: #e2e8f0;
  --mc-bg-card: #ffffff;
  color: var(--mc-text-main);
  margin: 0 auto;
}

.active-wrapper {
  margin-bottom: 30px;
}

.section-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-subtitle {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.status-inline-wrapper {
  margin-bottom: 25px; 
  display: flex;       
}

.status-badge {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
}

.status-badge.active {
  background: #ecfdf5;
  color: var(--mc-success);
  border: 1px solid #a7f3d0;
}

.status-badge.inactive {
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.pulse-dot {
  width: 6px;
  height: 6px;
  background: currentColor;
  border-radius: 50%;
}

.dashboard-card {
  background: var(--mc-bg-card);
  border-radius: 12px;
  border: 1px solid var(--mc-border);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.dashboard-body-triad {
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

@media (min-width: 900px) {
  .dashboard-body-triad {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
}

.column-label {
  font-size: 16px;
  font-weight: 700;
  color: #29b9f6;
  margin-bottom: 10px;
  margin-top: 0;
}

.column-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.data-group label {
  display: block;
  font-size: 0.85rem;
  color: var(--mc-text-muted);
  margin-bottom: 4px;
}

.data-value {
  font-size: 1rem;
  font-weight: 500;
  color: var(--mc-text-main);
  margin: 0;
}

.highlight-text {
  font-weight: 700;
  color: #29b9f6;
  font-size: 1.1rem;
}

.vertical-divider {
  width: 1px;
  background-color: var(--mc-border);
  align-self: stretch;
  margin: 0 20px;
}

.desktop-only {
  display: none;
}

@media (min-width: 900px) {
  .desktop-only {
    display: block;
  }
}

.column-action-card {
  flex: 0 0 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.billing-card-clean {
  width: 100%;
  background: #fcfcfc;
  border-radius: 16px;
  padding: 25px;
  text-align: center;
  border: 1px solid var(--mc-border);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.billing-label {
  font-size: 16px;
  font-weight: 600;
  color: #29b9f6;
  margin-bottom: 20px;
}

.billing-price-row {
  margin: 10px 0 20px 0;
  display: flex;
  justify-content: center;
  align-items: baseline;
  color: var(--mc-text-main);
}

.billing-price-row .currency {
  font-size: 1.5rem;
  font-weight: 600;
  margin-right: 2px;
}

.billing-price-row .amount {
  font-size: 3.5rem;
  font-weight: 800;
  letter-spacing: -2px;
  line-height: 1;
}

.billing-price-row .mxn {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--mc-text-muted);
  margin-left: 8px;
}

.btn-stripe-clean {
  width: 100%;
  justify-content: center;
  background-color: #29b9f6;
  color: white;
  font-weight: 600;
  padding: 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(70, 82, 232, 0.2);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
}

.btn-stripe-clean:hover {
  background-color: var(--mc-primary-dark);
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(70, 82, 232, 0.3);
}

.billing-security {
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.btn-cancel-subtle {
  margin-top: 15px;
  background: none;
  border: none;
  color: #94a3b8;
  font-size: 0.85rem;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.2s;
}

.btn-cancel-subtle:hover {
  color: #ef4444;
}

.column-benefits {
  flex: 1;
}

.clean-benefits-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.clean-benefits-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 0.95rem;
  color: var(--mc-text-muted);
  margin-bottom: 16px;
  line-height: 1.4;
}

.icon-check-primary {
  background: #29b9f61a;
  color: #29b9f6;
  padding: 4px;
  border-radius: 50%;
  font-size: 0.7rem;
  margin-top: 2px;
}

.generic-info-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  text-align: center;
}

.info-card {
  background: #f8fafc;
  padding: 40px;
  border-radius: 12px;
  border: 1px dashed #cbd5e1;
  max-width: 500px;
}

.info-icon {
  font-size: 3rem;
  color: #94a3b8;
  margin-bottom: 20px;
}

.info-card h3 {
  color: #334155;
  margin-bottom: 15px;
}

.info-card p {
  color: #64748b;
  line-height: 1.6;
}

.rol-tag {
  background: #eff6ff;
  color: #4652e8;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
}

.sub-text {
  font-size: 0.9rem;
  margin-top: 20px;
  color: #94a3b8;
}
</style>